import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';

export interface TypeHeadingWithTextBlockFields {
  heading?: EntryFieldTypes.Symbol;
  text?: EntryFieldTypes.RichText;
}

export type TypeHeadingWithTextBlockSkeleton = EntrySkeletonType<
  TypeHeadingWithTextBlockFields,
  'headingWithTextBlock'
>;
export type TypeHeadingWithTextBlock<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeHeadingWithTextBlockSkeleton, Modifiers, Locales>;

export function isTypeHeadingWithTextBlock<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeHeadingWithTextBlock<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'headingWithTextBlock';
}
